const DAY_IN_MS = 24 * 60 * 60 * 1000;

export function getCalendarDayDifference(
  targetDateInput?: string | Date | null,
  fromDate: Date = new Date(),
): number | null {
  if (!targetDateInput) {
    return null;
  }

  const targetDate = new Date(targetDateInput);
  if (Number.isNaN(targetDate.getTime())) {
    return null;
  }

  const targetDay = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
  const fromDay = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());

  return Math.round((targetDay.getTime() - fromDay.getTime()) / DAY_IN_MS);
}
